import { Component, DestroyRef, ViewChild, inject, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface typeData {
  id: any;
  data: any;
}

export interface typeElement {
  id: string;
  event_type: string;
  created_date: string;
  action: any;
}


@Component({
  selector: 'app-event-type',
  templateUrl: './event-type.component.html',
  styleUrls: ['./event-type.component.scss'],
  standalone: false
})
export class EventTypeComponent {
  displayedColumns: string[] = [
    'id',
    'event_type',
    'created_date',
    'action',
  ];

  ELEMENT_DATA: typeElement[] = [];
  event_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<typeElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) { }

  ngAfterViewInit() {
    this.getType();
    this.dataSource.paginator = this.paginator;
  }

  addtype() {
    const dialogRef = this.dialog.open(AddEventTypeComponent, {
      data: {
        // user_id: this.user_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getType();
    });
  }

  Edit_type(id: any) {
    const dialogRef = this.dialog.open(AddEventTypeComponent, {
      data: {
        id: id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getType();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Deletetype(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Type?');
    if (buttonClicked === true) {
      this.service.delete_event_type(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.toastr.success('Advertise Deleted Successfully');
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
        });
    }
  }

  getType() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_eventtype().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            id: item.id,
            event_type: item.event_type,
            created_date: item.created_date,
            action: item.id
          });
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<typeElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
}


@Component({
  selector: 'add-event-type',
  templateUrl: './add-event-type.html',
  styleUrls: ['./event-type.component.scss'],
  standalone: false
})
export class AddEventTypeComponent {

  addtypeForm: FormGroup;
  image_name: any;

  message!: string;
  logofileURL!: string | ArrayBuffer | null;
  logoPath: any;
  isOld1 = false;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;

  id: any;
  private destoryRef = inject(DestroyRef);
  typemain: any;
  event_type: any;

  constructor(
    private member: FormBuilder,
    private addservice: ServicesService,
    private dialogRef: MatDialogRef<AddEventTypeComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: typeData
  ) {
    this.id = data['id'];
    this.addtypeForm = this.member.group({
      id: this.id,
      image_name: new FormControl(''),
      event_type: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.get_advertise_by_id(this.id);
  }

  get_advertise_by_id(id: any) {
    this.addservice.get_event_type_by_id(id).subscribe(
      (data: any) => {
        this.typemain = data.data;
        this.imagePath = this.typemain[0].image_name;
        this.event_type = this.typemain[0].event_type;
      });
  }


  onFormSubmit() {

    this.addtypeForm.patchValue({
      image_name: this.imagePath,
    })
    const formData = this.addtypeForm.value;

    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.addtypeForm.valid && hasNonEmptyField) {
      if (this.id) {
        this.addservice.edit_event_type(this.addtypeForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Point Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.addservice.add_event_type(this.addtypeForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Point Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}